import React from "react";

const MinusRoundedIcon = React.forwardRef(
  (
    {
      size = 34,
      variant = "solid",       
      bgColor = "#F76E79",     
      barColor = "#FFFFFF",    
      rx = 8,                  
      strokeColor = "#9296AC", 
      className,
      ...props
    },
    ref
  ) => {
    const isOutline = variant === "outline";

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        {isOutline ? (
          <rect x="0.5" y="0.5" width="33" height="33" rx={rx - 0.5} stroke={strokeColor} />
        ) : (
          <rect width="34" height="34" rx={rx} fill={bgColor} />
        )}

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 17C8.25 16.3096 8.80964 15.75 9.5 15.75H24.5C25.1904 15.75 25.75 16.3096 25.75 17C25.75 17.6904 25.1904 18.25 24.5 18.25H9.5C8.80964 18.25 8.25 17.6904 8.25 17Z"
          fill={isOutline ? strokeColor : barColor}
        />
      </svg>
    );
  }
);

export default React.memo(MinusRoundedIcon);
